import { ReactComponent as Logomark } from '../images/logomark.svg';

/**
 * Oversized ArchiPro monogram that opens the standard article (Figma
 * 2354:55634). It is parked in the left margin, clear of the centred header
 * column, with its foot resting on the headline block. Decorative — the global
 * nav carries the linked logo — so it is hidden from assistive tech, and from
 * mobile, which has no design for it. Sizes in rem at the 1920 artboard (÷16),
 * base + md: only, matching the article-revamp siblings.
 */
export const RevampLogomark = () => (
    <Logomark
        aria-hidden="true"
        className="ml-[3.1875rem] hidden h-[10.375rem] w-[13.7235rem] self-start md:mt-7 md:block"
    />
);
